import React from 'react';
import { Icon } from 'react-fa';
import './Reportes.css';

const PantallaReporte = ({ reporte, volver }) => {		

    const url = reportesUrl + reporte.path;

	return (
    <div>

      <div className="TituloReporte">
         <Icon className="IconChevron clickable" name="chevron-left" size="lg" onClick={() => volver()} />
         <p>{reporte.description}</p>
      </div>

      <div className="iframeReporte">
         <iframe src={url} height="560px" width="983px"></iframe>		
      </div>

	</div>
	);	
}

export default PantallaReporte;


// WEBPACK FOOTER //
// ./Portico/App/Screens/InvocadorReportes/components/PantallaReporte.jsx